import { Avatar, Typography } from '../../../designComponents';
import {
  InfoRowStyled,
  VerticalSpaceStyled,
} from '../../../style/reusableStyle';
import { ViewProposalContainerStyled } from './style';
type Props = {
  technicianName: string;
  emailAddress: string;
  avatar: string;
};
const ProfessionalInformation = (props: Props) => {
  return (
    <ViewProposalContainerStyled>
      <Typography
        variant="normal"
        className="title-header"
        fontColor="secondary"
        strong
      >
        TECHNICIAN INFORMATION
      </Typography>
      <VerticalSpaceStyled>
        <InfoRowStyled>
          <Typography className="title">Technician Name : </Typography>

          <div className="profile">
            <Avatar size="md" src={props.avatar} />
            <Typography className="value">{props.technicianName}</Typography>
          </div>
        </InfoRowStyled>
        <InfoRowStyled>
          <Typography className="title">Email Address :</Typography>

          <Typography className="value">{props.emailAddress}</Typography>
        </InfoRowStyled>
      </VerticalSpaceStyled>
    </ViewProposalContainerStyled>
  );
};

export default ProfessionalInformation;
